import React from 'react';

import EssayGridCell from './essay-grid-cell';

import '../../styles/essays/homepage-essay-grid.scss';

const HomepageEssayGrid = (props) => (
  <div className="essay-grid homepage-essay-grid single-row-3up">
    {props.essayEdges.map(({ node }, idx) => (
      <EssayGridCell
        key={`homepage-essays-${idx}`}
        slug={node.data.Slug}
        title={node.data.Title}
        featuredImagePath={node.data.Featured_Image_Path}
        summary={node.data.Intro}
        contributors={node.data.Contributors}
        categories={node.data.Categories}
        series={node.data.Series}
        publishedDate={node.data.Published_Date}
        suppressSummary={true}
      />
    ))}
  </div>
);

export default HomepageEssayGrid;